var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApAgingSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.08 25.417H29.92c-1.099 0-2.046 0-2.826.063-.824.068-1.643.216-2.431.618a6.25 6.25 0 0 0-2.732 2.731c-.401.788-.55 1.608-.617 2.431-.064.78-.064 1.728-.064 2.826V50.08c0 1.099 0 2.046.064 2.826.067.824.216 1.643.617 2.431a6.25 6.25 0 0 0 2.732 2.732c.788.401 1.607.55 2.43.617.781.064 1.728.064 2.826.064H50.08c1.099 0 2.046 0 2.826-.064.824-.067 1.643-.215 2.431-.617a6.25 6.25 0 0 0 2.732-2.732c.401-.788.55-1.607.617-2.43.064-.781.064-1.728.064-2.827V34.086c0-1.098 0-2.045-.064-2.826-.067-.823-.215-1.643-.617-2.43a6.25 6.25 0 0 0-2.732-2.732c-.788-.402-1.607-.55-2.43-.618-.781-.063-1.728-.063-2.827-.063Z",
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 62.917c5.753 0 10.417-4.664 10.417-10.417S58.253 42.083 52.5 42.083 42.083 46.747 42.083 52.5 46.747 62.917 52.5 62.917Zm2.083-14.584a2.083 2.083 0 0 0-4.166 0V52.5c0 .553.22 1.082.61 1.473l2.083 2.084a2.083 2.083 0 1 0 2.947-2.947l-1.474-1.473v-3.304Z",
    fill: "#A0C9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 23.333a2.083 2.083 0 1 0-4.167 0V27.5a2.083 2.083 0 1 0 4.167 0v-4.167ZM50.417 23.333a2.083 2.083 0 1 0-4.167 0V27.5a2.083 2.083 0 0 0 4.167 0v-4.167Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApAgingSummary);
export default __webpack_public_path__ + "static/media/ap-aging-summary.b0e706bf.svg";
export { ForwardRef as ReactComponent };